export enum Role {
  admin = 'admin'
}
